module.exports = __webpack_public_path__ + "media/tap.bf4e4303.wav";